import { SocialProofBlock } from './SocialProofBlock'
import type { SocialProofPage as SocialProofPageType } from '@/content/quiz/types'

interface SocialProofPageProps {
  page: SocialProofPageType
  onContinue: () => void
}

export function SocialProofPage({ page }: SocialProofPageProps) {
  const config = {
    testimonials: page.testimonials ?? true,
    ratings: page.ratings ?? true,
    stats: page.stats ?? false,
  }

  return (
    <div className="space-y-6">
      <SocialProofBlock config={config} />
    </div>
  )
}
